import { AbiFunction } from 'ox';
import { erc20Functions } from '../../abi.js';
import { hex } from '../../utils.js';
export function buildApproveTx(params) {
    const data = AbiFunction.encodeData(erc20Functions.approve, [
        hex(params.spender),
        params.amount,
    ]);
    return { to: params.token, data };
}
